import { styled } from "@mui/material/styles";
import { thinScrollbar } from "@UI";
import React from "react";
import { useTranslation } from "react-i18next";
import { MessageItem } from "./MessageItem";
import { shouldShowWaitingIndicator } from "./utils/waitingIndicator";
import { WaitingIndicator } from "./WaitingIndicator";
const ListContainer = styled("div")({
    display: "flex",
    flexDirection: "column",
    gap: "var(--j-sp-8)",
    padding: "var(--j-sp-3) var(--j-sp-1-5) var(--j-sp-8) var(--j-sp-3)",
    "& > [data-role=user] + [data-role=assistant], & > [data-role=user] + [role=status]": {
        marginTop: "calc(var(--j-sp-3) - var(--j-sp-8))"
    },
    overflowY: "scroll",
    flex: 1,
    minHeight: 0,
    ...thinScrollbar
});
export function MessageList({ messages, isResponding, isBusy, onToolConfirmationResponse, onRetry, toolDecisions, respondingToolIds, choiceAnswers }) {
    const { t } = useTranslation();
    const containerRef = React.useRef(null);
    const pinnedRef = React.useRef(true);
    const [isStepsSpinning, setIsStepsSpinning] = React.useState(false);
    const onScroll = React.useCallback(()=>{
        const el = containerRef.current;
        if (!el) return;
        const distanceFromBottom = el.scrollHeight - el.scrollTop - el.clientHeight;
        pinnedRef.current = distanceFromBottom < 80;
    }, []);
    const showWaiting = !isStepsSpinning && shouldShowWaitingIndicator(messages, Boolean(isResponding));
    React.useLayoutEffect(()=>{
        const el = containerRef.current;
        if (el && pinnedRef.current) el.scrollTop = el.scrollHeight;
    });
    React.useEffect(()=>{
        const el = containerRef.current;
        if (!el) return undefined;
        const observer = new ResizeObserver(()=>{
            if (pinnedRef.current) el.scrollTop = el.scrollHeight;
        });
        observer.observe(el);
        return ()=>observer.disconnect();
    }, []);
    return /*#__PURE__*/ React.createElement(ListContainer, {
        ref: containerRef,
        onScroll: onScroll,
        role: "log",
        "aria-live": "polite",
        "aria-relevant": "additions",
        "aria-busy": isBusy || undefined,
        "aria-label": t("chat.messages")
    }, messages.map((message, index)=>{
        const isLast = index === messages.length - 1;
        return /*#__PURE__*/ React.createElement(MessageItem, {
            key: message.id,
            message: message,
            isStreaming: isLast && Boolean(isResponding),
            isLast: isLast,
            onToolConfirmationResponse: onToolConfirmationResponse,
            onStepsSpinning: setIsStepsSpinning,
            onRetry: isLast && !isResponding ? onRetry : undefined,
            toolDecisions: toolDecisions,
            respondingToolIds: respondingToolIds,
            choiceAnswers: choiceAnswers
        });
    }), showWaiting && /*#__PURE__*/ React.createElement(WaitingIndicator, null));
}
